module.exports = "/images/vendor/desiigner-svg/svg/places/hot-air-balloon.svg?513eeae5862e887edf2169f51fdda7f7";